export default function renderComponent(Component) {
	return <Component />;
}
